import { FocusNode } from '@please/lrud'
import styled from 'styled-components'

import { BackgroundImage } from '@/containers/styles'

export const FeatureScreenWrapper = styled.div`
  position: fixed;
  width: 1920px;
  height: 1080px;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
`

export const ContentBox = styled.div`
  position: relative;
  margin: 0 auto;
  height: 928px;
  width: 1768px;
  position: relative;
  background: radial-gradient(
    85.28% 210.12% at 10.34% 14.72%,
    ${(props) => props.theme.colors.app.background.start} 0%,
    ${(props) => props.theme.colors.app.background.end} 100%
  );
  overflow: hidden;
  ${BackgroundImage} {
    height: 100%;
  }
`
export const ButtonBox = styled(FocusNode)`
  position: absolute;
  bottom: 60px;
  right: 70px;
  display: flex;
  align-items: center;
`
